import type { Metric } from '../../types';

interface MetricCardProps {
  metric: Metric;
}

export default function MetricCard({ metric }: MetricCardProps) {
  return (
    <div className="bg-gradient-to-br from-[rgba(21,24,35,0.96)] to-[rgba(11,13,23,0.98)] rounded-2xl border border-border-soft p-3 flex flex-col gap-2 relative overflow-hidden">
      <div className="text-[0.75rem] text-text-soft">{metric.label}</div>
      <div className="flex items-baseline gap-1.5">
        <div className="text-[1.05rem] font-semibold">{metric.value}</div>
        {metric.change && (
          <span className={`text-[0.7rem] px-2 py-0.5 rounded-full ${
            metric.change.type === 'up' 
              ? 'bg-success/[0.12] text-success' 
              : 'bg-danger/[0.12] text-danger'
          }`}>
            {metric.change.value}
          </span>
        )}
      </div>
      {metric.footer && (
        <div className="text-[0.7rem] text-text-soft flex justify-between items-center">
          <span>{metric.footer.left}</span>
          {metric.footer.right && (
            <span className="text-accent cursor-pointer hover:underline">{metric.footer.right}</span>
          )}
        </div>
      )}
      <div className="absolute right-[-40px] bottom-[-40px] w-[120px] h-[120px] bg-[radial-gradient(circle,rgba(226,183,20,0.18)_0,transparent_60%)] opacity-80" />
    </div>
  );
}
